import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, useTheme, Typography, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { GroupWork } from '@material-ui/icons';

import { connect } from 'react-redux';
import { getDocuments, getIdentities, getBundles, getConfig } from '../../../../actions';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const WorkspaceMenu = (props) => {
  const { groups, group, config, subgroup, setLoading, config: { role } } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  let history = useHistory();

  const { t } = useTranslation();

  const theme = useTheme();
  const [color, setColor] = useState(theme.palette.primary.main);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setAppConfig = async (selectGroup, selectSubgroup, selectRole) => {
    try {
      setAnchorEl(null);// close menu
      setLoading(true);
      await props.getConfig(config.user, selectGroup, selectSubgroup, selectRole);
      setLoading(false);
    } catch (err) {
      console.error('Error when getting Application table: ', err);
    }
  };

  const handleChangeContext = async (selectGroup, selectSubgroup, selectRole) => {
    if (selectGroup !== group || subgroup !== selectSubgroup || role !== selectRole) {
      // Take app data,
      await setAppConfig(selectGroup, selectSubgroup, selectRole);
    }
    history.push('/');
  };

  return (
    <div>
      <IconButton
        aria-controls='simple-menu'
        aria-haspopup='true'
        onMouseEnter={() => setColor('white')}
        onMouseLeave={() => setColor(theme.palette.primary.main)}
        onClick={handleClick}
      >

        <GroupWork fontSize='large' style={{ color: `${color}` }} />
      </IconButton>
      <Menu
        id='context-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock
        style={{ top: 40, left: -100 }}
      >
        <div style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 5 }}>
          <Typography variant='subtitle2' style={{ color: 'gray' }}>{t('workspaceMenu:selectWorkspace')}</Typography>
          <Divider />
        </div>
        {groups && groups.map(({ context: { config: { name: configName } }, context: { name: contextName }, role: { name: roleName } }, index) => {
          return (
            <MenuItem key={`menuItem_${configName}_${contextName}_${roleName}`} value={index} onClick={() => handleChangeContext(configName, contextName, roleName)}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>{`${configName} - ${contextName} - ${roleName}`}</div>
                <div style={{ width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>{subgroup === contextName && role === roleName && <div style={{ height: 10, width: 10, borderRadius: 20, backgroundColor: theme.palette.primary.main }} />}</div>
              </div>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config,
    groups: state.config.groups,
    group: state.config.group,
    subgroup: state.config.subgroup
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConfig: (user, group, subgroup, role) => dispatch(getConfig(user, group, subgroup, role)),
    getDocuments: () =>
      dispatch(getDocuments()),
    getIdentities: () =>
      dispatch(getIdentities()),
    getBundles: () =>
      dispatch(getBundles())
  };
};

WorkspaceMenu.propTypes = {
  groups: PropTypes.array.isRequired,
  group: PropTypes.string.isRequired,
  subgroup: PropTypes.string.isRequired,
  config: PropTypes.object.isRequired,
  setLoading: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceMenu);
